import React, { useEffect, useState } from "react";
import "../styles/HomePage.css";
import "../styles/style.css";
import sageImage from "../assets/images/sage.png";
import backCircle from "../assets/backcircle.png";
import bhrigu from "../assets/images/bhrigu.png";
import lineage from "../assets/images/lineage.png";
import lineage2 from "../assets/images/lineage2.png";
import lineage3 from "../assets/images/lineage3.png";
import lineage4 from "../assets/images/lineage4.png";
import lineage5 from "../assets/images/lineage5.png";
import lineage6 from "../assets/images/lineage6.png";
import facebookLogo from "../assets/images/FBIcon.png";
import xLogo from "../assets/images/xIcon.png";
import linkedin from "../assets/images/linkedinIcon.png";
import { useNavigate } from "react-router-dom";
import config from "../services/config";
import ResetPassword from "../component/ResetPassword";
import NewPassword from "../component/NewPassword";
import Loader from "../utilities/Loader";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import Swal from "sweetalert2";
export default function HomePage() {
  const navigate = useNavigate();
  // const lineageImages = [lineage, lineage2, lineage3, lineage4, lineage5, lineage6];
  const [currentLineage, setCurrentLineage] = useState(0);
  const [socialData, setSocialData] = useState([]);
  const [showReset, setShowReset] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [formData, setFormData] = useState({ id: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    getSocialMedia();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // Get query parameters
    const showPwd = params.get("showNewPassword"); // "true" string
    const userEmail = params.get("email"); // "krishna@gmail.com"
    setShowNewPassword(showPwd === "true"); // convert string to boolean
    // Clean email string (remove quotes if any)
    const cleanEmail = userEmail ? userEmail.replace(/"/g, "") : "";

    // Store in localStorage
    if (cleanEmail) {
      localStorage.setItem("email", cleanEmail);
    }
  }, []);

  const getLocation = async () => {
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
        //   (error) => {

        //     if (isOrganisationUser) {
        //       handleOpenDialog(
        //         "Error",
        //         "Location access is required for organization users.",
        //         "error"
        //       );
        //     }
        //   }
        );
      } 
      else {
        console.log("Geolocation is not supported by this browser.");
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Location detect karna
  useEffect(() => {
    getLocation();
  }, []);


  const getSocialMedia = async () => {
    try {
      const payload = {
        company_id: 1, // Replace with actual company ID
      };
      const response = await config.getSocialMediaByCompany(payload);
      if (response.success === true) {
        setSocialData(response.data);
        console.log("Social Media Data:", response.data);
      } else {
        console.error("Failed to fetch social media data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching social media data:", error);
    }
  };

  const getIncreaseRegisterVisit = async () => {
    try {
      const response = await config.increaseRegisterVisit("");
      console.log("Response count", response);
    } catch (error) { }
  };

  const handleRegisterClick = () => {
    try {
      navigate("/register");
      getIncreaseRegisterVisit();
    } catch (error) { }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    if (!formData.id.trim()) {
      newErrors.id = "ID is required";
    }
    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true); // start loader

    try {
      const payload = {
        email: formData.id,
        password: formData.password,
        latitude: location?.latitude,
        longitude: location?.longitude,

      };
      const response = await config.login(payload);

      if (response.success) {
        localStorage.setItem("email", response.success.email);
        localStorage.setItem("id", response.success.id);
        localStorage.setItem("name", response.success.name);

        if (response.success.is_pwd_changed === false) {
          localStorage.setItem("reset_token", formData.password);

          setShowNewPassword(true);
        } else {
          localStorage.setItem("token", response.success.token);
          navigate("/dashboard");
        }
      }

      console.log("Login success:", response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text:
          error?.response?.data?.error ||
          "Something went wrong. Please try again.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false); // stop loader always
    }
  };

  return (
    <div className="homepage">
      <div className="row responsive">
        {showReset && (
          <ResetPassword
            onClose={() => setShowReset(false)}
            onOtpVerified={() => setShowNewPassword(true)}
          />
        )}
        {showNewPassword && (
          <NewPassword onClose={() => setShowNewPassword(false)} />
        )}
        {/* LEFT HALF */}
        <div className="col-md-6 mt-30">
          <div className="sage">
            <div className="backcircle">
              <img src={backCircle} alt="Halo" className="" />
            </div>
            <img
              src={sageImage}
              alt="Sage"
              className="img-responsive sage-img"
            />
          </div>
        </div>

        {/* RIGHT HALF */}
        <div className="col-md-4 mt-70 product">
          <div className="logo-section textcenter">
            <div>
              <img src={bhrigu_logo} alt="Bhrigu Logo" />
            </div>
            {/* <div className="logo">   <img src={bhrigu} alt="Bhrigu" className="bhrigu-fixed" /></div>
                    <div className="bhrigu-title">
                        <img
                            src={lineageImages[currentLineage]}
                            alt="Lineage"
                            className="lineage-rotating"
                        />
                    </div> */}
          </div>
          {loading && <Loader />}
          {/* Social text row */}
          <div className="row spacearound">
            <div className="product-1">
              <h3>
                <a
                  href={
                    socialData.find((s) => s.platform === "Website")?.url || "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  .COM
                </a>
              </h3>
            </div>
            <div className="product-1">
              <h3>
                <a
                  href={
                    socialData.find((s) => s.platform === "YouTube")?.url || "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>YOUTUBE</span>
                </a>
              </h3>
            </div>
            <div className="product-1">
              <h3>
                <a
                  href={
                    socialData.find((s) => s.platform === "Instagram")?.url ||
                    "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  INSTA
                </a>
              </h3>
            </div>
          </div>

          {/* Social icons row */}
          <div className="centercontent">
            <a
              href={
                socialData.find((s) => s.platform === "Facebook")?.url || "#"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="fbSocial"
            >
              <img src={facebookLogo} alt="Facebook" />
            </a>
            <a
              href={
                socialData.find((s) => s.platform === "Twitter")?.url || "#"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="fbSocial"
            >
              <img src={xLogo} alt="X" />
            </a>
            <a
              href={
                socialData.find((s) => s.platform === "LinkedIn")?.url || "#"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="fbSocial"
            >
              <img src={linkedin} alt="X" />
            </a>
          </div>

          {/* Auth section */}
          <div className="row registedlogin responsive">
            <div className="col-md-6">
              <h2>Sign in</h2>
              <input
                type="text"
                name="id"
                placeholder="ID"
                value={formData.id}
                onChange={handleChange}
              />
              {errors.id && <span style={{ color: "red" }}>{errors.id}</span>}
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && (
                <span style={{ color: "red" }}>{errors.password}</span>
              )}
              <div className="colrow">
                <a
                  onClick={() => setShowReset(true)}
                  style={{ cursor: "pointer" }}
                >
                  Forgot Password
                </a>
                <button className="submitbtn" onClick={handleSubmit}></button>
              </div>
            </div>
            <div className="col-md-6">
              <h2>Register</h2>
              <div className="textcenter block">
                <div id="loggedin" onClick={handleRegisterClick}>
                  <div
                    type="radio"
                    name="Register-btn"
                    id="registerbtn"
                    value="Register"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
